__turbopack_context__.v({
  "banner": "FooterBanners-module-scss-module__nhsSmW__banner",
  "banners": "FooterBanners-module-scss-module__nhsSmW__banners",
  "carousel": "FooterBanners-module-scss-module__nhsSmW__carousel",
  "cell": "FooterBanners-module-scss-module__nhsSmW__cell",
  "count-1": "FooterBanners-module-scss-module__nhsSmW__count-1",
  "wrapper": "FooterBanners-module-scss-module__nhsSmW__wrapper",
});
